import { createNavigation } from "next-intl/navigation";
import nProgress from "nprogress";
import { routing } from "./routing";

/*
// Wrapper of next-intl around next/navigation to use the same Link and useRouter throughout the app, regardless of the router we are using (app or pages)
// When the migration from the pages router to the app router is done, we can keep only this one and delete the navigation.js
*/

const { Link, redirect, usePathname, useRouter } = createNavigation(routing);

function useAppRouter() {
  const router = useRouter();
  const pathname = usePathname();

  function startNProgress(path) {
    nProgress.start();

    if (pathname === path) {
      nProgress.done();
    }
  }

  function push(path, options) {
    startNProgress(path);

    router.push(path, options);
  }

  function replace(path, options) {
    startNProgress(path);

    router.replace(path, options);
  }

  return {
    ...router,
    push,
    replace,
  };
}

export { Link, redirect, usePathname, useAppRouter as useRouter };
